import styled from 'styled-components';
import { colors } from '../../../styles/_vars';

const StyledSuccessStep = styled.div`
  width: 100%;
  max-width: 740px;
  text-align: left;

  h3 {
    margin-bottom: 25px;
    font-size: 24px;
    text-align: center;
    color: #17936F;
  }
  
  &.history {
    padding: 39px 70px 13px;
    background-color: #fff;
    margin: 100px auto;
    position: relative;
    
  }

  .success-step__tx-hash {
    margin-bottom: 40px!important;
  }

  .success-title {
    margin-bottom: 25px;
  }

  .transaction-arrows {
    width: 76px!important;
    height: auto;
    margin: 0 auto 20px;
    display: block;
  
    &.inverted {
      transform: rotate(180deg) scaleX(-1);
    }
  }

  .transaction-amount {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .actual-amount {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    color: #00B480;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
    white-space: nowrap;
    
    .icon-val-wrapper { 
      display: flex;
      align-items: center;
    }
    
    &.grey {
      color: #707070;
    }
  }

  [class^="currency-symbol-"] {
    margin-right: 3px;
      &:before {
       height: 24px;
       width: 24px;
       background-size: 24px auto!important;
      }
  }

  .converted-amount {
    font-size: 14px;
    color: #999999;
    font-weight: 400;
    margin-bottom: 25px;
  }
  
  .info-row {
    display: flex;
    flex-direction: row;
    padding-bottom: 15px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
  
    &:last-of-type {
      margin-bottom: 40px;
    }
  }
  
  .block {
    display: flex;
    flex-direction: column;
    
    &.left {
    width: 65%;
    }
  
    &.wide {
      width: 100%;
    }
    
    &.mobile {
      padding-bottom: 15px;
      border-bottom: 1px solid #ccc;
      margin-bottom: 20px;
    }
  }
  
  .row-title {
    color: #999;
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 10px;
  }
  
  .row-info {
    display: flex;
    flex-direction: row;
    color: #555;
    font-size: 15px;
    font-weight: 400;
    overflow-x: visible;
    text-overflow: ellipsis;
    position: relative;
  
    &.link {
      a {
        color: #17936F;
        text-decoration: underline;
      }
    }
  
    &.confirmed{ color: ${colors.green}; }

    &.pending { color: ${colors.greenLight}; }

    &.declined { color: ${colors.grayDarker2}; }
    
    .tx-loader{
      display: inline-block;
      
      .twokey-spinner{
        width: 25px;
        height: 25px;
      }
    }
    
    .copy {
      position: relative;
      left: 4px;
      cursor: pointer;
      
      .copy-tx {
        font-size: 19px;
        color: #ccc;
      }
      
      &:hover {
        .copy-tx {
          color: #999;
        }
      }
    }
  }
  
  .converted-amount.fees {
    font-size: 12px;
    color: #999;
    margin: 0 0 25px 25px;
  }
  
  .fees {
    display: inline;
    justify-content: space-between;
  }
  
  .button-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  
    button {
      width: 200px;
      height: 35px;
      margin-bottom: 15px;
    }
  
    .close-button {
      font-size: 14px;
      color: #999;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  
  .currency-symbol-2key {
    &:before {
      content: '\\e822';
      color: #fff;
      background: linear-gradient(180deg, rgba(11,195,126,1) 0%, rgba(17,170,118,1) 51%, rgba(22,151,112,1) 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      font-size: 24px;
      justify-content: center;
    }
  }
  
  .currency-symbol-eth-colored {
    top: 5px;
    position: relative;
    
    &:before {
      background-size: 14px auto!important;
    }
  }
  
  .currency-symbol-dai {
    top: 4px;
    position: relative;
    
    &.before {
      background-size: 24px auto!important;
      width: 25px;
    }
  }

  .custom-token {
    margin: 0 5px 0 0!important;
    height: 24px!important;
    width: auto!important;
  }
  
  .close-icon {
    width: 21px;
    height: auto;
    position: absolute;
    top: 19px;
    right: 24px;
    cursor: pointer;
  }

  .message-box-wrapper {
    border-radius: 4px;
    border: 1px solid transparent;
    margin: 15px auto 20px auto;
    width: 100%;
    padding: 10px;
    text-align: center;
  }

  @media screen and (max-width: 550px) {
    .success-title {
    
      h3 {
        font-size: 22px;
        margin-bottom: 20px;
      }
      
      .transaction-amount {

        .actual-amount { margin-bottom: 3px; }
        .converted-amount { margin-bottom: 0; }
      }
    }
  
    .info-row { flex-direction: column; }
    
    .row-info.link a {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    
    .converted-amount.fees {
      font-size: 15px;
      margin: 0;
    }
    
    .fees { display: flex; }
    
    .button-wrap button {
      width: 280px;
      height: 45px;
    }
  }
`;

export default StyledSuccessStep;
